import { render, staticRenderFns } from "./ComplaintInfo.vue?vue&type=template&id=c2e90568&scoped=true&"
import script from "./ComplaintInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintInfo.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintInfo.vue?vue&type=style&index=0&id=c2e90568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e90568",
  null
  
)

export default component.exports